import RelationshipMetadata from "../../RelationshipMetadata";

class AdminOrganizationAdminOrganizationPositionRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminOrganizationAdminOrganizationPosition";
        this.parentEnterpriseComponent = "AdminOrganization";
        this.childEnterpriseComponent = "AdminOrganizationPosition";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "OrganizationUSID";
    }
}

export default AdminOrganizationAdminOrganizationPositionRelationshipMetadata;